<template lang="pug">
.container
  h4 {{$t('Device Commands')}}:
  el-table(v-if="newEditedDevice.DeviceCommands && newEditedDevice.DeviceCommands.length > 0", :data='newEditedDevice.DeviceCommands', style='width: 100%', size='mini')
    el-table-column(prop='name', :label='$t("Name")')
    el-table-column(prop='body', :label='$t("Body")')
    el-table-column(fixed='right', label='')
      template(slot-scope='scope')
        el-button(id="EditCommands-deleteButton" @click='deleteCommand(scope.row)', type='primary', size='mini')
          i.el-icon-delete
  el-button(id="EditCommands-showAddCommand" type='info', size="mini", @click='showNewCommandForm()', plain)
    i.el-icon-plus
  el-dialog(:close-on-click-modal="false", :visible.sync='addCommandFormVisible', append-to-body, @close='closeNewCommandForm()')
    el-row
      el-col(:span="22")
        h4 {{$t('Add Command')}}
    el-row
      el-col(:span="24")
        el-card
          el-form(:model='newCommand', :size="uxParam('formSize')")
            el-form-item
              el-input(id="EditCommands-nameInput" :placeholder='$t("name")', v-model='newCommand.name')
                template(slot='prepend' , width="200px") {{$t('Name')}}
            el-form-item
              el-input(id="EditCommands-bodyInput" :placeholder='$t("body")', v-model='newCommand.body')
                template(slot='prepend' , width="200px") {{$t('Body')}}
            el-button.float-right(id="EditCommands-addCommandButton" type='primary', size="mini", @click='createNewCommand()')
              span {{ $t('Add Device command')}}
            br
            br
</template>

<script>
import Vue from 'vue'

export default {
  props: ['side', 'newEditedDevice'],
  created () {
  },
  data () {
    return {
      errors: {
      },
      addCommandFormVisible: false,
      newCommand: {}
    }
  },
  methods: {
    async deleteCommand (command) {
      await Vue.axios
        .delete('deviceCommand/' + command.id)
        .then(response => {
          this.$store.dispatch('Device/deleteDeviceCommand', response.data)
        })
    },
    async createNewCommand () {
      await Vue.axios
        .post('deviceCommand', { Device: this.newEditedDevice.id, name: this.newCommand.name, body: this.newCommand.body })
    },
    showNewCommandForm () {
      this.addCommandFormVisible = true
    },
    closeNewCommandForm () {
      this.addCommandFormVisible = false
    }
  },
  computed: {
    devices () {
      return this.$store.state.Device.device_list
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
</style>



// WEBPACK FOOTER //
// src/components/Device/EditCommands.vue